// import Vue3VideoPlayer from "@cloudgeek/vue3-video-player";
//@ts-ignore
import vClickOutside from "click-outside-vue3";

export default defineNuxtPlugin(nuxtApp => {
    // nuxtApp.vueApp.use(Vue3VideoPlayer);
  nuxtApp.vueApp.use(vClickOutside);

  })